(function () {
    'use strict';

    // Important: add all available fields to MembershipTemplate variable!
    // IsPrimary thing is screwed up especially on cancel!!!!!!!!!!!!!!!!!!!!!!!!!

    angular
        .module('app.memberAdmin')
        .component('sc3Membership', {
            templateUrl: 'app/member-admin/membership/membership.component.html',
            controller: MembershipComponent,
            bindings: {
                individualId: '<',
                memberships: '<'
            }
        });

    var forEach = angular.forEach,
        copy = angular.copy,
        noop = angular.noop,
        extend = angular.extend,
        Membership,
        MembershipTemplate = { clubMembershipId: null, individualId: null, clubId: null, clubName: null, levelId: null, level: null, isPrimary: null,  status: null, joinDate: null, renewDate: null, category: null, isClubActive: null, localId: null, bagStorageId: null, lockerId: null };

    MembershipComponent.$inject = ['$q', 'Club', 'Member', 'user', 'createProxyClass', 'clubMembershipStatus', 'defaultAdminClubSearchPageSize', 'alert', 'memberAdminResources', 'gettext', 'confirm', 'clubMembershipCategory'];
    function MembershipComponent($q, Club, Member, user, createProxyClass, clubMembershipStatus, clubSearchPageSize, alert, resources, gettext, confirm, clubMembershipCategory) {
        // Variables
        var ctrl = this, Membership, statusList, currentSearch;

        // Properties
        ctrl.categories = Object.keys(clubMembershipCategory.$metadata);
        ctrl.datePickerOptions = null;
        ctrl.isEditing = false;
        Object.defineProperty(ctrl, 'canDelete', { get: function () { return !ctrl.isEditing && ctrl.isAssociationAdmin; } });
        Object.defineProperty(ctrl, 'isAssociationAdmin', { get: function () { return user.isAssociationAdmin; } });
        ctrl.isLimitedClubAdmin = user.isLimitedClubAdmin;
        ctrl.isHandicapChair = user.isHandicapChair;

        // Core Methods
        ctrl.$onInit = init;
        ctrl.insert = insert;
        ctrl.edit = edit;
        ctrl.save = save;
        ctrl.remove = remove;
        ctrl.cancel = cancel;
        ctrl.restore = restore;

        // Typeahead Methods
        ctrl.clubInit = clubInit;
        ctrl.clubSearch = clubSearch;
        ctrl.clubChanged = clubChanged;

        // Supplentary Model Methods
        ctrl.levelIdChanged = levelIdChanged;
        ctrl.toggleStatus = toggleStatus;
        ctrl.toggleIsPrimary = toggleIsPrimary;

        // Misc Methods
        ctrl.getPrimaryTooltip = getPrimaryTooltip;
        ctrl.isInactive = isInactive;
        ctrl.isArchived = isArchived;
        ///////////////////////////////////

        // ** Core Methods
        function init() {
            var date,
                datePickerOptions = ctrl.datePickerOptions = {};

            // Proxify items in array
            if (!Membership)
                Membership = createProxyClass(MembershipTemplate);
            ctrl.memberships = ctrl.memberships.map(Membership);

            // Set statusList
            statusList = [clubMembershipStatus.Active, clubMembershipStatus.Inactive ];

            // set datePickerOptions
            date = new Date();
            date.setHours(0, 0, 0, 0);
            datePickerOptions.minDate = date;
            date = new Date();
            date.setFullYear(date.getFullYear() + 2);
            datePickerOptions.maxDate = date;
        }
        function insert() {
            var membership = new Membership({ individualId: ctrl.individualId, status: clubMembershipStatus.Active })
            ctrl.memberships.push(membership);
            ctrl.edit(membership);
        }
        function edit(membership) {
            var clubId = membership.clubId,
                promise;

            promise = !clubId ? $q.resolve([]) : Club.getClubLevels({ id: clubId }, true).$promise.then(ensureCount)
            promise.then(success, error);

            ///////////////////////

            function success(levels) {
                membership.$levels = levels;
                membership.edit();
                ctrl.isEditing = true;
            }
            function error() {
                alert.error(resources.fetchMembershipLevelsFailed);
            }
            function ensureCount(data) {
                return data && data.length ? data : $q.reject();
            }
        }
        function save(membership, form) {
            form.$setSubmitted();
            if (form.$valid) {
                Member.saveMembership({ id: ctrl.individualId }, membership, success, error, true);
            }

            function success(data) {
                var primaryId = data.$primaryClubMembershipId;
                membership.commit(data);
                setPrimary(primaryId);
                ctrl.isEditing = false;
            }
            function error() {
                alert.error(resources.saveMembershipFailed);
            }
        }
        function remove(membership) {
            setStatus(membership, clubMembershipStatus.Archived, resources.confirmArchiveMembership, resources.archiveMembershipFailed);
        }
        function cancel(membership) {
            membership.rollback();
            membership.$isPrimary = membership.isPrimary;
            if (!membership.clubMembershipId)
                removeFromArray(membership)
            ctrl.isEditing = false;
        }

        function restore(membership) {            
            Member.restoreArchivedMembership({ id: membership.clubMembershipId }, success, error, true);

            function success(data) {
                membership.status = clubMembershipStatus.Inactive;
                copy(data, membership);
            }
            function error() {                
                alert.error(errorMessage);
            }    
        }

        // ** Typeahead Methods
        function clubInit(membership, scope) {
            scope.club = membership.clubId ? { id: membership.clubId, name: membership.clubName } : null;
        }
        function clubSearch(text) {
            var params = { individualId: user.id, $skip: 0, $top: clubSearchPageSize, $filter: { search: text } };
            if (currentSearch)
                currentSearch.$cancelRequest();
            return (currentSearch = Club.getAdminClubs(params)).$promise.then(success);

            function success(data) {
                return data.data;
            }
        }
        function clubChanged(membership, $model) {
            var clubId = $model && $model.id || null,
                clubName = $model && $model.name || null;

            // Ensure that it really changed
            if (clubId != membership.clubId) {
                membership.clubId = clubId;
                membership.clubName = clubName;
                ctrl.edit(membership);
            }
        }

        // ** Supplentary Model Methods
        function levelIdChanged(membership) {
            var levels = membership.$levels || [],
                level = levels.find(predicate);

            membership.level = level && level.level || null;

            function predicate(level) {
                return level.id == membership.levelId;
            }
        }
        function toggleStatus(membership) {
            var status = membership.status,
                index = statusList.indexOf(status),
                newIndex = (index + 1) % statusList.length,
                newStatus = statusList[newIndex];

            membership.status = newStatus;
            if (membership.status !== clubMembershipStatus.Active)
                membership.isPrimary = false;
        }
        function toggleIsPrimary(membership) {
            membership.isPrimary = !membership.isPrimary;
        }

        // ** Misc Methods
        function getPrimaryTooltip(isPrimary) {
            return isPrimary ? gettext('Primary Membership') : gettext('Secondary Membership');
        }
        function isInactive(membership) {
            return membership.status !== clubMembershipStatus.Active;
        }
        function isArchived(membership) {
            return membership.status === clubMembershipStatus.Archived;
        }

        // ** Helpers
        function removeFromArray(membership) {
            var index = ctrl.memberships.indexOf(membership);
            if (index != -1)
                ctrl.memberships.splice(index, 1);
        }
        function setPrimary(primaryId) {
            ctrl.memberships.forEach(setIsPrimary);
            function setIsPrimary(membership) {
                membership.isPrimary = membership.clubMembershipId === primaryId;
            }
        }
        function setStatus(membership, status, confirmationMessage, errorMessage) {
            confirm(confirmationMessage).then(save, noop);

            function save() {
                var originalStatus = membership.status;
                membership.status = status;
                Member.saveMembership({ id: ctrl.individualId }, membership, success, error, true);

                function success(data) {
                    copy(data, membership);
                }
                function error() {
                    membership.status = originalStatus;
                    alert.error(errorMessage);
                }
            }
        }
    }
})();
